import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { CartNotEmptyGuard, CheckoutPlaceOrderModule } from '@spartacus/checkout/base/components';
import { CmsConfig, ConfigModule, I18nModule, UrlModule } from '@spartacus/core';
import { CustomCheckoutAuthGuard } from '../../guards/custom-checkout-auth.guard';
import { CustomPlaceOrderComponent } from './custom-place-order.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    UrlModule,
    I18nModule,
    ReactiveFormsModule,
    ConfigModule.withConfig({
      cmsComponents: {
        CheckoutPlaceOrder: {
          component: CustomPlaceOrderComponent,
          guards: [CustomCheckoutAuthGuard, CartNotEmptyGuard],
        },
      },
    } as CmsConfig),
  ],
  declarations: [CustomPlaceOrderComponent],
  exports: [CustomPlaceOrderComponent]
})
export class CustomPlaceOrderModule extends CheckoutPlaceOrderModule { }
